module.exports = __webpack_public_path__ + "static/18-997714d28bd0e73a646eb6b77c9f8ae8.jpg";